var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M30,23.25a17.041,17.041,0,0,1-5.355-.855,1.531,1.531,0,0,0-1.53.36l-3.3,3.3A22.568,22.568,0,0,1,9.93,16.17l3.3-3.315a1.44,1.44,0,0,0,.375-1.5A17.041,17.041,0,0,1,12.75,6a1.5,1.5,0,0,0-1.5-1.5H6A1.5,1.5,0,0,0,4.5,6,25.5,25.5,0,0,0,30,31.5,1.5,1.5,0,0,0,31.5,30V24.75A1.5,1.5,0,0,0,30,23.25ZM28.5,18h3A13.5,13.5,0,0,0,18,4.5v3A10.492,10.492,0,0,1,28.5,18Zm-6,0h3A7.5,7.5,0,0,0,18,10.5v3A4.494,4.494,0,0,1,22.5,18Z",
    transform: "translate(-4.5 -4.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a4d6a0878cb53d6b29cb4a9194c72949.svg";
export { ForwardRef as ReactComponent };